import axios from '@/axios';

const RESOURCE_NAME = '/admin/markets/sectors';

export default {
    getList() {
        return axios.post(`${RESOURCE_NAME}/get-list`)
    },

    getIndexList(data) {
        return axios.post(`${RESOURCE_NAME}/get-index-list`, data)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },
}
